import { render, staticRenderFns } from "./ViewMember.vue?vue&type=template&id=b2124fac&"
import script from "./ViewMember.vue?vue&type=script&lang=js&"
export * from "./ViewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports